// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1IDZo","loaderOuter":"PageOverlayLoader_loaderOuter__28CHL"};